import React from 'react';

import { StyledText } from './Text.styles';
import { TextProps } from './Text.types';

const Text = ({
  children,
  componentTag: ComponentTag = 'div',
  textVariantList,
  textColorVariant,
  componentClassname = 'text',
  customClassnames = '',
  customStyle = '',
  ...props
}: TextProps) => {
  let componentClassnames = `${componentClassname} ${customClassnames} ${
    textColorVariant ? `${componentClassname}--${textColorVariant}` : ''
  }`;

  if (textVariantList && Array.isArray(textVariantList)) {
    textVariantList.forEach((variant) => {
      componentClassnames += ` ${componentClassname}--${variant}`;
    });
  }

  return (
    <StyledText
      as={ComponentTag}
      {...props}
      className={componentClassnames}
      customStyle={customStyle}
      textVariantList={textVariantList}
      textColorVariant={textColorVariant}
    >
      {children}
    </StyledText>
  );
};
Text.displayName = 'Text';

export default Text;
